module.exports = __webpack_public_path__ + "static/flags/MG-72f77649126bdb0e1dd4a59949719ebd.gif";